import styled from 'styled-components'

export const ImageWrapper = styled.div.attrs({
  className: `h-40 sm:h-72 my-10 sm:my-20 mx-auto`,
})``

export const ImageWrapperSmall = styled.div.attrs({
  className: `h-40 my-10 mx-auto`,
})``
